<template>
  <div
    class="activity listen-activity activity-with-button"
    :class="{ mandatory: mandatory, complete: complete }"
  >
    <AudioPlayer
      :audio-id="audioId"
      :cms-audio-src="cmsAudioSrc"
      :track-title="trackTitle"
      :album-title="albumTitle"
      :on-listen-end="onListenEnd"
      :is-complete="complete"
    >
      <slot></slot>
    </AudioPlayer>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { debug as d } from "debug";
import AudioPlayer from "../audio-player.vue";

const debug = d("cs.ListenActivityComponent");

const props = withDefaults(
  defineProps<{
    activityId: string;
    mandatory: boolean;
    cmsAudioSrc: string;
    complete: boolean;
    trackTitle: string;
    albumTitle: string;
  }>(),
  {
    complete: false,
  },
);

const emit = defineEmits(["activity-completed"]);

const audioId = computed(() => props.activityId);

const onListenEnd = () => {
  debug("onListenEnd");
  if (!props.complete) {
    debug("Completing listening activity");
    emit("activity-completed", props.activityId);
  }
};
</script>
<style lang="less" scoped></style>
